const routers = [
  {
    // 部门
    path: '/department/list',
    name: 'department',
    component: () => import('@/views/modules/organization/department/List.vue')
  },
  {
    // 员工
    path: '/employee/list',
    name: 'employee',
    component: () => import('@/views/modules/organization/employee/List.vue')
  }
]
export default routers
